import React from 'react';

const Navbar = () => {

    return (
        <nav className="header navbar text-white bg-secondary fixed-top">

            <div className="container">

                <div className="w-100 d-flex justify-content-center justify-content-sm-start">

                    <img src="/images/zealstream_logo.svg" alt="ZealStream Logo" height={32} className="d-inline-block align-text-top my-1 logo" />

                </div>

            </div>

        </nav>
    )
    
}

export default Navbar